import { render, staticRenderFns } from "./graphics.vue?vue&type=template&id=1bdc4c85&scoped=true"
import script from "./graphics.vue?vue&type=script&lang=js"
export * from "./graphics.vue?vue&type=script&lang=js"
import style0 from "./graphics.vue?vue&type=style&index=0&id=1bdc4c85&prod&lang=less&scoped=true"
import style1 from "./graphics.vue?vue&type=style&index=1&id=1bdc4c85&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdc4c85",
  null
  
)

export default component.exports